import { useQuery } from '@tanstack/react-query'
import { getJSON } from '@/lib/api'
import type { MemberSessionResponse } from './MemberSignIn'
import { memberSessionKey } from './memberPortalSession'

// Identifies the signed-in person in organization query keys so one person's figures never
// survive into another person's session.
export function usePortalViewer() {
  const session = useQuery<MemberSessionResponse>({
    queryKey: memberSessionKey,
    queryFn: () => getJSON('/api/v1/member_portal/session'),
    enabled: false,
  })
  const person = session.data?.person
  return JSON.stringify([person?.id, person?.name, person?.email])
}
